var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: "沿海岸警戒監測資訊", show_search_text: false },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("MonitorOptionSet", {
              ref: "monitor_option_set",
              attrs: { option_set: _vm.option_set },
              on: { filter_data: _vm.filter_data },
              scopedSlots: _vm._u(
                [
                  _vm.option_set.length !== 0
                    ? {
                        key: "remarks",
                        fn: function() {
                          return undefined
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            })
          ]
        },
        proxy: true
      },
      {
        key: "description",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "signs__description" },
              _vm._l(Object.entries(_vm.icons), function(ref) {
                var text = ref[0]
                var icon = ref[1]
                return _c(
                  "span",
                  { key: text },
                  [
                    _c("v-icon", { class: "multiple-signal--" + icon.color }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(icon.name) +
                          "\n                "
                      )
                    ]),
                    _vm._v(
                      "\n                " + _vm._s(text) + "\n            "
                    )
                  ],
                  1
                )
              }),
              0
            )
          ]
        },
        proxy: true
      },
      {
        key: "signs",
        fn: function() {
          return [
            _vm.sign_data
              ? _c("MonitorMultipleSigns", { attrs: { data: _vm.sign_data } })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function() {
          return [
            _c("ScenicAreaMonitor", {
              key: _vm.default_value_weather,
              attrs: {
                default_value: _vm.default_value_weather,
                table_data: _vm.table_data_weather,
                show_download_pdf_btn: true
              },
              on: {
                transfer_immutable_table_data:
                  _vm.get_immutable_table_data_weather
              }
            }),
            _vm._v(" "),
            _c("ScenicAreaMonitor", {
              key: _vm.default_value_buoy,
              attrs: {
                default_value: _vm.default_value_buoy,
                table_data: _vm.table_data_buoy,
                show_download_pdf_btn: true
              },
              on: {
                transfer_immutable_table_data: _vm.get_immutable_table_data_buoy
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }